import RelationToOneField from '@/shared/fields/relation-to-one-field';
import { CommonService } from '@/shared/services/common.service';

export class TerritorialAdministrativeUnitField {
    static relationToOne(name, label, rules, filterParams, children, options) {
        return new RelationToOneField(
            name,
            label,
            CommonService.territorialAdministrativeUnitsAssignedListAutocomplete,
            (record) => {
                if (!record) {
                    return '';
                }

                return {
                    value: record.id,
                    text: record.name,
                };
            },
            rules,
            filterParams,
            children,
            options,
        );
    }
}
